var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.75,
    y: 3.75,
    width: 22.5,
    height: 19.5,
    rx: 1.5,
    ry: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.75 9.75h22.5M6.75 6V.75M17.25 6V.75M5.625 13.5h0M5.625 13.5a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375M5.625 18.75h0M5.625 18.75a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375M12 13.5h0M12 13.5a.375.375 0 1 0 .375.375A.375.375 0 0 0 12 13.5M12 18.75h0M12 18.75a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375M18.375 13.5h0M18.375 13.5a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375M18.375 18.75h0M18.375 18.75a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar3);
export default __webpack_public_path__ + "static/media/calendar-3.19c0758503ecbf72a5a7c32447f0101f.svg";
export { ForwardRef as ReactComponent };